<template lang="pug">
  //- div(:style="containerStyle"
  //-   @dragover="dragover_handler($event)"
  //-   @drop="dragFinish($event)")
  //-   slot
  //-     //- div(
  //-     //-   :style="innerStyle"
  //-     //-   v-for="(item, i) in listInfo"
  //-     //-   draggable="true"
  //-     //-   @dragstart="dragStart(i, $event)"
  //-     //-   @dragenter="dragEnter($event)"
  //-     //-   @dragleave="dragLeave"
  //-     //-   @dragend="dragEnd"
  //-     //-   )
  //-     //-   input(type="checkbox" :value="item.id" v-model="selectedIndex")
  //-     //-   span() {{ item.title }}

  //-   slot(name="table")
  //-     div.rTable
  //-       div.rTableRow
  //-         div.rTableHead
  //-         div.rTableHead(v-for="infoTitle in listTitle") {{ infoTitle }}
  //-       div.rTableRow(v-for="(infoObject, i) in listInfo"
  //-         draggable="true"
  //-         @dragstart="dragStart(i, $event)"
  //-         @dragenter="dragEnter($event)"
  //-         @dragleave="dragLeave"
  //-         @dragend="dragEnd")
  //-         div.rTableCell
  //-           input(type="checkbox" :value="infoObject.id" v-model="selectedIndex")
  //-         div.rTableCell {{ infoObject.value }}

  div
    slot
    slot(name="customizeDragAndDrop")

</template>

<script>
export default {
  name: "DragAndDrop",
  props: {
    // containerStyle: {
    //   type: String,
    //   default: ""
    // },
    // innerStyle: {
    //   type: String,
    //   default: ""
    // },
    // listTitle: {
    //   type: Array,
    //   default: {}
    // },
    // listInfo: {
    //   type: Array,
    //   default: {}
    // },
    // tableHeader: {

    // }
  },
  data() {
    return {
      selectedIndex: [],
      dragging: -1,
      dragFromPos: "",
      group: "",
      dragDone: false
    }
  },
  methods: {
    ///// https://codepen.io/pasoev/pen/ooOrpo
    // Drag
    // dragStart: function(which, ev, fromPos, groupInfo, dragListLength) {
    //   this.dragDone = false;
    //   this.dragFromPos = fromPos;
    //   this.group = groupInfo;
    //   ev.dataTransfer.dropEffect = 'move';

    //   //////////////////////////////////////////
    //   //============ Ghost Image =============//
    //   // https://kryogenix.org/code/browser/custom-drag-image.html
    //   // https://stackoverflow.com/questions/34200023/drag-drop-set-custom-html-as-drag-image
    //   var elem = document.createElement("div");
    //   elem.id = "divGhostImg";
    //   elem.textContent = dragListLength + " row selected";
    //   elem.style.position = "absolute";
    //   elem.style.top="-1000px";
    //   elem.style.width="100px";
    //   elem.style.height="20px";
    //   elem.style.backgroundColor="#ffffff";
    //   document.body.appendChild(elem);
    //   ev.dataTransfer.setDragImage(elem, -20, -10);
    //   ///////////////////////////////////////
    // },
    // dragEnter: function(ev, dragFinPos) {
    //   // if(dragFinPos == "toC") {
    //   //   ev.dataTransfer.dropEffect = "none";
    //   //   return;
    //   // }
    // },
    // dragover_handler: function(ev, groupInfo) {
    //   if(this.group != groupInfo) {
    //     ev.preventDefault();
    //     ev.dataTransfer.dropEffect = "none";
    //   }

    //   else {
    //     ev.preventDefault();
    //     ev.dataTransfer.effectAllowed = "move";
    //   }
    // },
    // dragLeave: function(ev) {
    //   /*
    //   ev.target.style.marginTop = '2px'
    //   ev.target.style.marginBottom = '2px'
    //   */
    // },
    // dragEnd: function(ev) {
    //   var dragElementGhostImg = document.getElementById("divGhostImg");
    //   if(dragElementGhostImg != null) {
    //     dragElementGhostImg.remove();
    //   }

    //   return this.dragDone;
    // },
    // dragFinish: function(ev, dragFinPos, dragList, listA, listB, groupInfo) {
    //   if(this.group != groupInfo)
    //     return;

    //   this.moveItem(dragList, listA, listB);
    // },
    // moveItem: function(dragList, listA, listB) {
    //   if (dragList.length === -1)
    //     return;

    //   else {
    //     for(var i = 0; i < dragList.length; i++) {
    //       if(this.dragFromPos == "fromMatchLookUp") {
    //         let j = listA.map(listAInfo => listAInfo.match_id).indexOf(dragList[i]);
    //         if(j != -1) {
    //           listB.push(listA[j]);
    //           listA.splice(j, 1);
    //           this.dragDone = true;
    //         }
    //       }

    //       else if(this.dragFromPos == "fromSelectedMatchLookUp") {
    //         let j = listB.map(listBInfo => listBInfo.match_id).indexOf(dragList[i]);
    //         listA.push(listB[j]);
    //         listB.splice(j, 1);
    //         this.dragDone = true;
    //       }
    //     }
    //   }
    // }


    dragStart: function(ev, fromPos, groupInfo, dragList) {
      this.dragDone = false;
      this.dragFromPos = fromPos;
      this.group = groupInfo;
      ev.dataTransfer.dropEffect = 'move';
      this.selectedIndex = dragList;
      this.createGhostImage(ev, dragList);
    },
    createGhostImage: function(ev, dragList) {
      this.selectedIndex = dragList;
      //////////////////////////////////////////
      //============ Ghost Image =============//
      // https://kryogenix.org/code/browser/custom-drag-image.html
      // https://stackoverflow.com/questions/34200023/drag-drop-set-custom-html-as-drag-image
      var elem = document.createElement("div");
      elem.id = "divGhostImg";
      elem.textContent = this.selectedIndex.length + " row selected";
      elem.style.position = "absolute";
      elem.style.top="-1000px";
      elem.style.width="100px";
      elem.style.height="20px";
      elem.style.backgroundColor="#ffffff";
      document.body.appendChild(elem);
      ev.dataTransfer.setDragImage(elem, -20, -10);
      ///////////////////////////////////////
    },
    destroyGhostImage: function() {
      var dragElementGhostImg = document.getElementById("divGhostImg");
      if(dragElementGhostImg != null) {
        dragElementGhostImg.remove();
      }
    },
    dragEnter: function(ev, dragFinPos) {
      // if(dragFinPos == "toC") {
      //   ev.dataTransfer.dropEffect = "none";
      //   return;
      // }
    },
    dragover_handler: function(ev, groupInfo) {
      if(this.group != groupInfo) {
        ev.preventDefault();
        ev.dataTransfer.dropEffect = "none";
      }

      else {
        ev.preventDefault();
        ev.dataTransfer.effectAllowed = "move";
      }
    },
    dragLeave: function(ev) {
      /*
      ev.target.style.marginTop = '2px'
      ev.target.style.marginBottom = '2px'
      */
    },
    dragEnd: function(ev) {
      this.destroyGhostImage();

      this.selectedIndex = [];
      this.dragFromPos = "";
      this.group = "";

      return this.dragDone;
    },
    dragFinish: function(ev, dragFinPos, listA, listB, groupInfo, prop) {
      if(this.group != groupInfo)
        return;

      this.moveItem(listA, listB, prop);
    },
    moveItem: function(listA, listB, prop) {
      if (this.selectedIndex.length === -1)
        return;

      else {
        for(var i = 0; i < this.selectedIndex.length; i++) {
          let j = listA.map(listAInfo => listAInfo[prop]).indexOf(this.selectedIndex[i]);
          if(j != -1) {
            listB.push(listA[j]);
            listA.splice(j, 1);
            this.dragDone = true;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// table css
.rTable {
  display: table;
  width: 100%;
  font-size: 0.72rem;
  font-weight: 600;
}
.rTableRow {
  display: table-row;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
}
.rTableHead {
  overflow: auto;
  background-color: #507CD1;
  color: #ffffff;
  font-weight: bold;;
}
.rTableResize {
  resize: horizontal;
}
.rTableCell, .rTableHead {
  display: table-cell;
  padding: 2px 8px;
  border: 1px solid #999999;
}
// .rTableCell {
//   background-color: #EEEEEE;
// }
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
  font-weight: bold;
}
.rTableFoot {
  display: table-footer-group;
  font-weight: bold;
  background-color: #ddd;
}
.rTableBody {
  display: table-row-group;
}
</style>
